import { Clock, Loader2, CheckCircle, AlertTriangle } from 'lucide-react';

const STATUS_META = {
    PENDING:    { icon: Clock,        color: '#94a3b8', label: 'En file' },
    GENERATING: { icon: Loader2,      color: '#f59e0b', label: 'Génération…', spin: true },
    READY:      { icon: CheckCircle,  color: '#22c55e', label: 'Prêt' },
    FAILED:     { icon: AlertTriangle, color: '#ef4444', label: 'Échec' },
};

// Bloc repliable « Générations récentes » : les 5 derniers sujets générés avec leur statut.
export default function RecentGenerations({ sousSujets, open, onToggle }) {
    const recent = (sousSujets || [])
        .filter(s => s.origin_type === 'PDF' || s.origin_type === 'AI_PROMPT' || s.origin_type === 'JSON_IMPORT')
        .slice(0, 5);
    if (recent.length === 0) return null;

    return (
        <div className="ms-recent">
            <button type="button" className="ms-recent__head" onClick={onToggle}>
                <span className="ms-recent__title">Générations récentes</span>
                <span className="ms-recent__count">{recent.length}</span>
                <span className={`ms-recent__chev ${open ? 'is-open' : ''}`}>▾</span>
            </button>
            {open && (
                <div className="ms-recent__list">
                    {recent.map(s => {
                        const meta = STATUS_META[s.status] || STATUS_META.PENDING;
                        const Icon = meta.icon;
                        return (
                            <div key={s.id} className="ms-recent__row">
                                <Icon size={13} className={meta.spin ? 'spin' : ''} style={{ color: meta.color, flexShrink: 0 }} />
                                <span className="ms-recent__name" style={{ color: s.status === 'FAILED' ? 'var(--text-muted)' : 'var(--heading)' }}>
                                    {s.sous_sujet_label}
                                </span>
                                <span className="ms-recent__status" style={{ color: meta.color }}>
                                    {meta.label}
                                    {s.status === 'READY' && <> · {s.nb_questions_active || s.nb_questions_generated || 0} Q</>}
                                </span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
